import { GridItem, Text, Flex, SkeletonText, } from '@chakra-ui/react';
import React from 'react';
const SkeletonLoadingAccordionField = ({ title, isLoading, value, valueTestId, ...rest }) => (React.createElement(React.Fragment, null,
    React.createElement(GridItem, null,
        React.createElement(Text, { "data-testid": "skeleton_loading_field__title", variant: "dk-800-md-3" }, title)),
    React.createElement(GridItem, null,
        React.createElement(Flex, { alignItems: "center", minH: "100%" },
            React.createElement(SkeletonText, { noOfLines: 1, w: "100%", isLoaded: !isLoading, ...rest },
                React.createElement(Text, { variant: "md-600-rg-3", "data-testid": valueTestId }, value))))));
export default SkeletonLoadingAccordionField;
